<template>
  <ak-button
    ref="button"
    :color="closeColor"
    circle
    size="small"
    :disabled="disabled"
    v-bind="attrs"
    @click="clicked"
  >
    <ak-icon :type="'close'"></ak-icon>
  </ak-button>
</template>

<script>
import { ref, computed, defineComponent } from 'vue'
import Icon from '../icon/Icon.vue'
import Button from '../button/Button.vue'
import { buttonMixin } from '../../mixins/buttonMixin'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-close />
   */
  name: 'AkClose',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Boolean}
     * @description This controls whether we render the as a disabled
     * button or not, this will prevent click handlers from triggering
     * if using the native button element class.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @type {Boolean}
     * @description Inverse the close button to be displayed on dark bg
     */
    inverse: {
      type: Boolean,
      default: false,
    },
  },

  /**
   * @type {Array}
   * @description The list of events that this component can trigger
   */
  emits: ['click'],

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props, { emit, attrs }) {
    const button = ref(null)

    const closeColor = computed(() => {
      return props.inverse ? 'transparent-light' : 'transparent'
    })

    const { clicked } = buttonMixin({
      button,
      props,
      emit,
    })

    return {
      closeColor,
      clicked,
      attrs,
    }
  },
})
</script>
